import React from 'react';
import { Globe } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';

export const BrandingTab = ({ settings, handleChange }) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <Globe className="w-5 h-5 text-indigo-700" />
        Branding da Plataforma
      </CardTitle>
      <CardDescription className="text-slate-500">
        Identidade visual global da plataforma
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-600">Nome da Plataforma</Label>
          <Input
            value={settings.platform_name}
            onChange={(e) => handleChange('platform_name', e.target.value)}
            placeholder="COGNIEtica"
            className="bg-white border-slate-300 text-slate-900"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-600">Email de Suporte</Label>
          <Input
            type="email"
            value={settings.support_email}
            onChange={(e) => handleChange('support_email', e.target.value)}
            placeholder="suporte@cognietica.pt"
            className="bg-white border-slate-300 text-slate-900"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-600">URL do Logo (opcional)</Label>
        <Input
          type="url"
          value={settings.platform_logo_url}
          onChange={(e) => handleChange('platform_logo_url', e.target.value)}
          placeholder="https://..."
          className="bg-white border-slate-300 text-slate-900"
        />
        <p className="text-xs text-slate-500">
          Logo exibido no header e emails
        </p>
      </div>

      <Separator className="bg-slate-700" />

      <div className="space-y-2">
        <Label className="text-slate-600 flex items-center gap-2">
          <Globe className="w-4 h-4" />
          URL Base Pública do Canal de Denúncias
        </Label>
        <Input
          type="url"
          value={settings.public_base_url}
          onChange={(e) => handleChange('public_base_url', e.target.value)}
          placeholder="https://etica.cogniseg.net"
          className="bg-white border-slate-300 text-slate-900"
          data-testid="public-base-url-input"
        />
        <p className="text-xs text-slate-500">
          O canal público de cada cliente será <code className="text-indigo-700">{(settings.public_base_url || 'https://etica.cogniseg.net').replace(/\/$/, '')}/&#123;slug&#125;</code>. Este valor é sincronizado com o CogniHub.
        </p>
      </div>
    </CardContent>
  </Card>
);
